import React from 'react';
import { BsFillFileEarmarkTextFill } from "react-icons/bs";
import { FaPlus, FaImages } from "react-icons/fa";
import { HiTemplate } from "react-icons/hi";
import SendMessage from './SendMessage';
// import SendMessage from '../content/ProspectContent/SendMessage';

const OptionsShippigProspects = ({onFileInput,showTooltip,setIsSendTemplate}) => {
    return (
        <div className="dropdown">
            <button
                className="bg-transparent border-0 d-flex"
                type="button"
                id="dropdownMenuButton"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
            >
                <FaPlus
                    className="icon-chat icon-plus"
                    style={{ fontSize: "28px", color: "#455a64", zIndex: "998" }}
                    aria-hidden="true"
                    data-tooltip-id={showTooltip ? "my-tooltip" : undefined} 
                    data-tooltip-content={showTooltip ? "Adjuntar" : undefined}
                />
            </button>

            <div className="dropdown-menu py-3 px-1" aria-labelledby="dropdownMenuButton" style={{ width: "230px" }}>
                <ul>
                    <li className="options-drop">
                        <input
                            type="file"
                            name="image"
                            id="images"
                            accept="image/gif,image/jpeg,image/jpg,image/png"
                            style={{ display: "none" }}
                            onChange={(e) => onFileInput(e, "image")}
                            multiple
                        />
                        <label htmlFor="images" title="Imagenes" className="pointer w-100 d-flex">
                            <FaImages className="mr-2 icon-picture" style={{ fontSize: "20px", color: "#007dfc" }}/>
                            Imagenes
                        </label>
                    </li>

                    <li className="options-drop">
                        <input
                            type="file"
                            name="documents"
                            id="documents"
                            accept=".pdf,.csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel, text/plain, .doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                            style={{ display: "none" }}
                            onChange={(e) => onFileInput(e, "document")}
                            multiple
                        />
                        <label htmlFor="documents" title="Documentos" className="pointer w-100 d-flex">
                            <BsFillFileEarmarkTextFill className="mr-2 icon-doc" style={{ fontSize: "22px", color: "#8165fd" }}/>
                            Documentos
                        </label>
                    </li>

                    <li
                        className="options-drop d-flex pointer"
                        onClick={() => {
                            setIsSendTemplate(true)
                        }}
                    >
                        <HiTemplate className="mr-2 tbTemplate pointer" style={{ fontSize: "20px", color: "#00a99b" }}/>
                        <label className="pointer">Enviar plantilla</label>
                    </li>
                
                </ul>
            </div>
        </div>
    );
};

export default OptionsShippigProspects;